import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  AllOperationsDTO,
  GenericPaginationDTO,
  FirstFiveOperationsDTO,
  OperationsDTO,
  PaginationResponseDTO,
  PaginationRequestAllDTO,
  Operation,
  CostumerMailDTO,
} from '@app/requests/model/requests-model';
import { environment } from '@env/environment';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class RequestPanelService {
  constructor(private _http: HttpClient) {}

  getOperationsPanel(): Observable<FirstFiveOperationsDTO> {
    return this._http.post<FirstFiveOperationsDTO>(environment.URL_BASE_REQUEST + environment.subUrlOperations, null);
  }

  getOperationsPanelPagination(genericPaginationDTO: GenericPaginationDTO): Observable<PaginationResponseDTO> {
    return this._http.post<PaginationResponseDTO>(
      environment.URL_BASE_REQUEST + environment.subUrlOperationsPagination,
      genericPaginationDTO
    );
  }

  getAllOperations(allOperationDTO: AllOperationsDTO): Observable<PaginationResponseDTO> {
    return this._http.post<PaginationResponseDTO>(
      environment.URL_BASE_REQUEST + environment.subUrlAllOperations,
      allOperationDTO
    );
  }

  getAllOperationsPagination(genericPaginationDTO: PaginationRequestAllDTO): Observable<PaginationResponseDTO> {
    return this._http.post<PaginationResponseDTO>(
      environment.URL_BASE_REQUEST + environment.subUrlAllOperationsPagination,
      genericPaginationDTO
    );
  }

  getAllOperationsFind(genericPaginationDTO: PaginationRequestAllDTO): Observable<PaginationResponseDTO> {
    return this._http.post<PaginationResponseDTO>(
      environment.URL_BASE_REQUEST + environment.subUrlAllOperationsFind,
      genericPaginationDTO
    );
  }

  postCancelRequest(request: Operation): Observable<boolean> {
    return this._http.post<boolean>(environment.URL_BASE_REQUEST + '//servicio', request);
  }

  postResendLink(request: CostumerMailDTO): Observable<boolean> {
    return this._http.post<boolean>(environment.URL_BASE_REQUEST + environment.subUrlResendLink, request);
  }
}
